import { useState } from "react"
import { NotificationGroup } from "./types"

interface Props {
    group: NotificationGroup;
    /** Function implementing navigation action for the component - this is temporary, to be removed when the whole module migrates to React */
    navigateFunc: (location: string) => void;
}

export function NotificationGroupComponent({ group, navigateFunc } : Props) {
    const [expanded, setExpanded] = useState<boolean>(group?.expanded ?? false);

    return <>
        <div className="sum" onClick={() => setExpanded(prev => !prev)}>
            <i className={`fas ${group.error ? 'fa-exclamation-circle' : 'fa-exclamation-triangle'}`}></i>
            {/* todo: sanitize the html before putting it into the page */}
            <span dangerouslySetInnerHTML={{ __html: group.summary}} />
        </div>

        {expanded &&
            <div className="exp">

                {/* todo: sanitize the html before putting it into the page */}
                <div className="descr" dangerouslySetInnerHTML={{ __html: group.description}} />

                <ul>
                    {/* todo: sanitize the html before putting it into the page */}
                    {group.details?.map((dt, index) => {
                        return <li key={index} 
                        className={dt.location ? 'link' : ''} 
                        onClick={() => navigateFunc(dt.location)} 
                        dangerouslySetInnerHTML={{ __html: dt.text}} />
                    })}
                </ul>

            </div>
        }
    </>
}